import * as types from "./types";

export const setTaker = ({
  id,
  first_name,
  last_name,
  email,
  cell_phoe,
  divisionId,
  role,
  feedback_groups,
  token: { digest, exp } = {},
}) => {
  return {
    type: types.SET_TAKER,
    payload: {
      id,
      first_name,
      last_name,
      email,
      cell_phoe,
      divisionId,
      role,
      feedback_groups,
      token: { digest, exp },
    },
  };
};

export const setToken = ({ digest, exp }) => {
  return {
    type: types.SET_TOKEN,
    payload: { digest, exp },
  };
};

export const setSubmittedCount = count => {
  return {
    type: types.SET_SUBMITTED_COUNT,
    payload: count,
  };
};

export const incrementSubmittedCount = () => {
  return {
    type: types.INCREMENT_SUBMITTED_COUNT,
  };
};

export const setSessionId = id => {
  return {
    type: types.SET_SESSION_ID,
    payload: id,
  };
};

export const set2FAasRequired = () => {
  return {
    type: types.SET_2FA_AS_REQUIRED,
  };
};
